import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Icon } from "@/components/Icon";
import { Badge } from "@/components/Badge";
import { Logo } from "@/components/Logo";

export const Home: React.FC = () => {
    const { t } = useTranslation("global");

    const featureCards = [
        {
            id: "construction",
            icon: "building" as const,
            title: t("home.cards.construction_title"),
            description: t("home.cards.construction_desc"),
            //accent: 'from-blue-500/10 to-indigo-500/5 text-blue-700 dark:text-blue-400 border-blue-200/80 dark:border-blue-500/30',
            accent: "text-blue-700 dark:text-blue-400",
        },
        {
            id: "resources",
            icon: "hardHat" as const,
            title: t("home.cards.resources_title"),
            description: t("home.cards.resources_desc"),
            //accent: 'from-amber-500/10 to-orange-500/5 text-amber-700 dark:text-amber-400 border-amber-200/80 dark:border-amber-500/30',
            accent: "text-amber-700 dark:text-amber-400",
        },
        {
            id: "certifications",
            icon: "clipboardCheck" as const,
            title: t("home.cards.certifications_title"),
            description: t("home.cards.certifications_desc"),
            //accent: 'from-emerald-500/10 to-teal-500/5 text-emerald-700 dark:text-emerald-400 border-emerald-200/80 dark:border-emerald-500/30',
            accent: "text-emerald-700 dark:text-emerald-400",
        },
    ];

    //absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-80 h-80 bg-gradient-to-tr from-primary/25 via-rose-500/15 to-amber-500/15 rounded-full blur-3xl pointer-events-none animate-pulse-glow
    return (
        <div className="space-y-8 animate-fade-in max-w-5xl mx-auto py-0 sm:py-0">
            {/* Hero Card */}
            <div className="relative bg-box rounded-3xl border border-slate-200/90 p-8 sm:p-12 shadow-sm overflow-hidden text-center">
                {/* Content */}
                <div className="relative z-10 flex flex-col items-center">
                    {/* Status Pill Badge */}
                    {/*
                    <Badge variant='primaryinverted' className='mb-8 px-4!'>
                        <span className="w-2 h-2 rounded-full bg-primary animate-pulse" />
                        <span className=''>{t('home.badge')}</span>
                    </Badge>
                    */}

                    {/* Floating Logo with subtle shadow */}
                    <div className="relative mb-6 p-2">
                        <Logo className="h-16 sm:h-20 md:h-24 w-auto object-contain filter drop-shadow-md animate-fade-logo" />
                    </div>

                    {/* Title and Subtitle */}
                    <h1 className="text-3xl sm:text-4xl md:text-5xl font-black text-slate-900 tracking-tight max-w-2xl">
                        {t("home.welcome")}
                    </h1>
                    <p className="text-sm sm:text-base text-slate-600 max-w-2xl mt-3 leading-relaxed">
                        {t("home.subtitle")}
                    </p>

                    {/* Call to Action Button */}
                    {/*
                    <div className="mt-8">
                        <Link
                            to="/developments"
                            className="btn btn-primary px-8 py-3.5 text-sm font-bold flex items-center space-x-2.5 shadow-lg shadow-primary/25 hover:shadow-xl hover:scale-[1.02] active:scale-[0.98] transition-all cursor-pointer"
                        >
                            <span>{t('home.button_developments')}</span>
                            <Icon value="arrowRight" size={17} />
                        </Link>
                    </div>
                    */}
                </div>
            </div>

            {/* Feature Highlights Grid */}
            {/* text-center group cursor-pointer transition-all duration-300 hover:-translate-y-1.5 hover:shadow-xl hover:shadow-slate-200/60 dark:hover:shadow-black/60 hover:border-primary/40 dark:hover:border-primary/50*/}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
                {featureCards.map((card) => (
                    <div key={card.id} className="box text-center">
                        <div>
                            {/*<div className={`w-12 h-12 mx-auto rounded-xl bg-gradient-to-br border flex items-center justify-center mb-4 transition-all duration-300 group-hover:scale-110 group-hover:shadow-md ${card.accent}`}>*/}
                            <div
                                className={`flex items-center justify-center mb-4 ${card.accent}`}
                            >
                                <Icon
                                    value={card.icon}
                                    size={30}
                                    className="m-auto"
                                />
                            </div>
                            <h2 className="text-base font-bold text-slate-900 dark:text-white tracking-tight transition-colors duration-200 group-hover:text-primary dark:group-hover:text-primary-400">
                                {card.title}
                            </h2>
                            <p className="text-xs text-slate-500 dark:text-slate-400 mt-2 leading-relaxed">
                                {card.description}
                            </p>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default Home;
